import { useUpdateActivityReporter } from '@/hooks/useUpdateActivityReporter';

export function UpdateActivityReporter() {
  useUpdateActivityReporter();
  return null;
}
